import { CloseOctagonOutlineIcon } from './CloseOctagonOutlineIcon';

/**
 * author: Simran
 * id 9676C4C3-D8C3-44A6-A447-59A56A15DA34
 * name close-octagon-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-octagon-outline.svg
 * tags
 */
export const RemoveOctagonOutlineIcon = CloseOctagonOutlineIcon;
export default RemoveOctagonOutlineIcon